import { useTranslation } from "react-i18next";

import { LANGUAGES, type Language } from "@/configs/i18n";
import { cn } from "@/lib/utils";

const LABELS: Record<Language, string> = {
  uz: "O'zbekcha",
  ru: "Русский",
  en: "English",
};

/**
 * Til tanlagich — segmentli boshqaruv.
 *
 * Tillar uchta va ko'paymaydi, shuning uchun ochiluvchi menyu ortiqcha:
 * bitta klik yetadi va joriy til doim ko'rinib turadi.
 */
export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current = (i18n.resolvedLanguage ?? "uz") as Language;

  return (
    <div
      role="group"
      aria-label={t("common.language")}
      className="bg-muted/70 border-border/60 flex h-8 items-center gap-0.5 rounded-full border p-0.5"
    >
      {LANGUAGES.map(language => {
        const active = language === current;

        return (
          <button
            key={language}
            type="button"
            lang={language}
            onClick={() => void i18n.changeLanguage(language)}
            aria-label={LABELS[language]}
            aria-current={active ? "true" : undefined}
            title={LABELS[language]}
            className={cn(
              "focus-visible:ring-ring/50 h-7 cursor-pointer rounded-full px-2 text-xs font-medium tracking-wide transition-colors outline-none focus-visible:ring-2",
              active
                ? "bg-card text-foreground shadow-xs"
                : "text-muted-foreground hover:text-foreground",
            )}
          >
            {language.toUpperCase()}
          </button>
        );
      })}
    </div>
  );
}
